// ABOUTME: no_enter_gate (dev, owner 2026-10-08): a returning guest whose consent is on file gets the agent connected SILENTLY at the
// ABOUTME: landing (welcome held, as staging holds it behind the CTA), so the welcome-back starts quickly after their tap.

import { useEffect, useRef, useState } from 'react';

/**
 * Armed while `enabled` holds. Entering does not change `enabled`, so entry never drops and reopens the early socket; an auth close
 * (1008: App sets isAuthenticated false, which is part of `enabled`) disarms it, so a re-login re-arms and the connect effect re-runs.
 *
 * @param {object} p
 * @param {boolean} p.enabled returning landing, consent decided (never before a first consent decision), authenticated
 * @param {Function} p.onArm App's arming: raise the film/hold gate synchronously (trap T-1: the connect URL reads it) and arm connect
 * @returns {boolean} the early connection is armed
 */
export default function useEarlyConnect({ enabled, onArm }) {
  const [armed, setArmed] = useState(false);
  const onArmRef = useRef(onArm);
  onArmRef.current = onArm;
  useEffect(() => {
    if (enabled && !armed) {
      console.log('[UX][LANDING] early connect: agent connecting silently, welcome held until the tap');
      onArmRef.current?.();
      setArmed(true);
    } else if (!enabled && armed) {
      setArmed(false);
    }
  }, [enabled, armed]);
  return armed;
}
